// extracted by mini-css-extract-plugin
export var closed = "button-sticky-module--closed--36375";
export var icon = "button-sticky-module--icon--7389f";
export var opened = "button-sticky-module--opened--a8ede";
export var title = "button-sticky-module--title--f348a";